const EditorTool = {
  SMART_PLUS: "SMART_PLUS",
  SMART_MINUS: "SMART_MINUS",
  PLUS: "PLUS",
  MINUS: "MINUS",
  ERASER: "ERASER",
};

export default EditorTool;
